export const PageHeader = ({ title, children }) => (
  <div className="topbar"><h4 className="m-0">{title}</h4>
    <div className="d-flex align-items-center gap-3">{children}</div></div>)
export const StatCard = ({ icon, value, label, bg = '#E8F1FF' }) => (
  <div className="card h-100"><div className="card-body d-flex align-items-center gap-3">
    <div className="stat-icon" style={{ background: bg }}>{icon}</div>
    <div><div className="fs-4 fw-bold lh-1">{value}</div><small className="text-muted">{label}</small></div></div></div>)
